import React from "react";
const IsVisSPCContext = React.createContext<{ isVisSPC: string; changeIsVis: (isVisSPC: string) => void } | null>(null);

export default IsVisSPCContext;
